import React from 'react'

import CngTreeview from '../../../../../components/clog/treeview'
import ErrorContent from '../components/ErrorContent'

function Documents(props) {
  if (props.docs && props.docs.length)
    return <CngTreeview data={props.docs} showExpandedSiblings />
  else
    return <ErrorContent>No related documents</ErrorContent>
}

export default Documents
